<cluster-engineering-header/>
<div class="app-container about-values pt-4 pb-5">
  <h2>CLUSTER ENGINEERING</h2>
  <p class="mt-4 about-text">
    The Cluster Engineering in BMW Techworks Romania plays a key role in shaping how BMW turns ideas into real products. We support the entire Idea-to-Offer process from the moment a market need is identified, all the way to delivering a product that’s ready for customers.
  </p>
  <p class="about-text">
    Think of it like this: It all starts with an insight or a new opportunity. From there, teams explore concepts, design solutions, and build the technical foundation. Then comes development, testing, and quality assurance — making sure everything works flawlessly and is ready for production at scale.  </p>
  <p class="about-text">
    Our job in the Engineering Cluster is to deliver, manage, and operate the software that makes this whole journey possible. We work with advanced technologies that differ across our cluster units, depending on the product and the stage of the process, but the goal is always the same: to provide reliable, intelligent IT solutions that support. innovation, ensure quality, and help transform ideas into market-ready products.
  </p>
</div>

<div class="app-container our-values pb-5 pt-5">
  <div class="cluster-engineering-cards">
    @for (item of infoCards; track item.title) {
      <box-item-flip [content]="item.content"
                     [imgClass]="item.imgClass"
                     [title]="item.title">
      </box-item-flip>
    }

  </div>
</div>
